import { ProjectUser } from '@monorepo/shared/apiClient/types';
import { MenuOption } from '@monorepo/shared/componentsV2/menus/Menu';
import { isOrgAdmin, NO_PERMISSION_TOOLTIP } from './sharedUtils';

const SELF_RESEND_TOOLTIP = 'You cannot resend an invite to yourself.';

const ORG_ADMIN_RESEND_TOOLTIP =
  'This user is an organization admin and does not need a site invitation.';

type ResendInviteActionParams = {
  user: ProjectUser;
  isSelf: boolean;
  canManageUsers: boolean;
  onResend: () => void;
};

export function getResendInviteAction({
  user,
  isSelf,
  canManageUsers,
  onResend,
}: ResendInviteActionParams): MenuOption {
  const getTooltip = () => {
    if (!canManageUsers) return NO_PERMISSION_TOOLTIP;
    if (isSelf) return SELF_RESEND_TOOLTIP;
    if (isOrgAdmin(user)) return ORG_ADMIN_RESEND_TOOLTIP;
    return undefined;
  };

  const disabledTooltip = getTooltip();

  return {
    displayName: 'Resend invite',
    onClick: onResend,
    disabled: !!disabledTooltip,
    tooltip: disabledTooltip,
  };
}
